import { render, staticRenderFns } from "./EntryContent.vue?vue&type=template&id=ec64171c&scoped=true"
import script from "./EntryContent.vue?vue&type=script&lang=js"
export * from "./EntryContent.vue?vue&type=script&lang=js"
import style0 from "./EntryContent.vue?vue&type=style&index=0&id=ec64171c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec64171c",
  null
  
)

export default component.exports